import { userActions } from "./auth-slice";
import { uiActions } from "../ui-slice";
import { ordenActions } from "../orden-store/orden-slice";

export const RegisterUser = (user) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Realizando nuevo registro de usuario",
        message: "Solicitando Creación del Usuario, por favor espere.",
      })
    );
    const GetUserByIdInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/register`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: user.email,
            ...user,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo crear el usuario");
      }
      const data = await response.json();

      return data;
    };
    try {
      const response = await GetUserByIdInfo();

      if (response.result.errorCode === "OK") {
        dispatch(
          userActions.setauth({
            auth: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Usuario Creado",
            message: response.result.message,
          })
        );
        dispatch(userActions.setIsRegister(true));
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear el usuariosssss",
        })
      );
    }
  };
};
export const ValidateToken = (token, id) => {
  return async (dispatch) => {
    const validateInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}user/validateToken`,
        {
          method: "POST",
          body: JSON.stringify({
            Id: id,
            TokenValidation: {
              Token: token,
              TokenType: "Register",
            },
            userName: "tokenvalidation@aba.org.do",
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se validar el token");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await validateInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Token validado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo validar el token",
        })
      );
    }
  };
};
export const ForgotPasswordAction = (email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitud realizada",
        message: "Se esta solicitando el cambio de contraseña",
      })
    );
    const loginInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/forgotpassword`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Email: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo solicitar el cambio de contraseña");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await loginInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userActions.setauth({
            auth: response.data,
          })
        );
        localStorage.setItem("token", response.data.token);
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Solicitud realizada",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo solicitar el cambio de contraseña",
        })
      );
    }
  };
};
export const ForgotPasswordInsideAction = (email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitud realizada",
        message: "Se esta solicitando el cambio de contraseña",
      })
    );
    const loginInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/forgotpassword`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Email: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo solicitar el cambio de contraseña");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await loginInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userActions.setauth({
            usuario: {
              email: response.data.email,
              fullName: response.data.fullName,
            },
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Solicitud realizada",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo solicitar el cambio de contraseña",
        })
      );
    }
  };
};
export const ChangePasswordAction = (token, userId, password) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando Cambio de contraseña",
        message: "Solicitando Cambio de contraseña al servidor.",
      })
    );
    const validateInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/changepassword`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: "recoverypassword@aba.org.do",
            id: userId,
            password: password,
            TokenValidation: {
              Token: token,
              TokenType: "forgotpassword",
            },
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo realizar el cambio de contraseña ");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await validateInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "cambio de contraseña completado",
            message: "Cambio de contraseña completado con exito",
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: "Este link de cambio de contraseña ya ha sido utilizado anteriormente",
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo realizar el cambio de contraseña",
        })
      );
    }
  };
};
export const ChangeTemporalPasswordAction = (email, userId, password) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando Cambio de contraseña",
        message: "Solicitando Cambio de contraseña al servidor.",
      })
    );
    const validateInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/changeTemporalpassword`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: userId,
            password: password,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo realizar el cambio de contraseña ");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await validateInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "cambio de contraseña completado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo realizar el cambio de contraseña",
        })
      );
    }
  };
};
export const SignIn = (email, password) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Iniciando Sesión",
        message: "",
      })
    );
    const loginInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/login`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Email: email,
            Password: password,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se realizar el inicio de sesión");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await loginInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Bienvenido",
            message: "Inicio de sesión exitoso",
          })
        );
        
        dispatch(userActions.settoken({ token: response.data.token }));
        localStorage.setItem("token", response.data.token);
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo realizar el inicio de sesión",
        })
      );
    }
  };
};
export const UpdateDetail = (email, user) => {
  return async (dispatch) => {
    const loginInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/updateDetail`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: user.id,
            Name: user.name,
            LastName: user.lastName,
            email: user.email,
            CellPhone: user.cellPhone,
            Country: user.country,
            City: user.city,
            Address: user.address,
            Company: user.company,
            Charge: user.charge,
            Department: user.department,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se realizar el inicio de sesión");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await loginInfo();
      if (response.result.errorCode === "OK") {
       
        localStorage.setItem("token", response.data.token);
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar los datos",
        })
      );
    }
  };
};
export const UpdatePassword = (user) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando datos",
        message: "",
      })
    );
    const loginInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/updatePassword`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: user.email,
            Id: user.id,
            Password: user.password,
            NewPassword: user.newPassword,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se realizar el inicio de sesión");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await loginInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Dataos actualizados",
            message: "Sus datos han sido actualizados",
          })
        );
        // dispatch(userActions.settoken({ token: response.data.token }));
        localStorage.setItem("token", response.data.token);
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar los datos",
        })
      );
    }
  };
};
export const GetUserByemail = (email, userName, users, dontShow) => {
  return async (dispatch) => {
    if (dontShow === undefined) {
    }
    const getUsuarioInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}admin/user/getByEmail`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            Email: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el usuario");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getUsuarioInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userActions.setauth({
            user: response.data,
            users: users,
          })
        );
        if (dontShow === undefined) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: response.result.message,
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          userActions.setauth({
            user: {},
            users: users,
          })
        );
        if (dontShow === undefined) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el Usuario",
        })
      );
    }
  };
};
export const CleanUser = () => {
  return async (dispatch) => {
    try {
      dispatch(
        userActions.setauth({
          auth: {
            email: "",
            name: "",
            lastName: "",
            identification: "",
            cellPhone: "",
            country: "",
            city: "",
            address: "",
            company: "",
            charge: {},
            department: {},
            status: false,
            token: "",
            fullName: "",
          },
        })
      );
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          // message: "No se pudo obtener el Usuario",
        })
      );
    }
  };
};

export const GetUserById = (id, userName, users, dontShow) => {
  return async (dispatch) => {
    if (dontShow === undefined) {
      dispatch(
        uiActions.showNotification({
          status: "pending",
          title: "Solicitando Usuario",
          message: "Solicitando Usuario al servidor.",
        })
      );
    }
    const getUsuarioInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/getById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            Id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el usuario");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getUsuarioInfo();
      if (response.result.errorCode === "OK") {

        
        dispatch(
          userActions.setauth({
            auth: response.data,
            auths: users,
          })
        );

        if (dontShow === undefined) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: response.result.message,
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          userActions.setauth({
            auth: {},
            auths: users,
          })
        );
        if (dontShow === undefined) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el Usuario",
        })
      );
    }
  };
};
export const GetOrdersByUserId = (id, userName, dontShow) => {
  return async (dispatch) => {
    if (dontShow === undefined) {
      dispatch(
        uiActions.showNotification({
          status: "pending",
          title: "Solicitando ordenes",
          message: "Solicitando ordenes al servidor.",
        })
      );
    }
    const getUsuarioInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/GetAllOrdenMadeByUserId`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            Id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el usuario");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getUsuarioInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          ordenActions.setOrden({
            orden: response.data,
          })
        );

        if (dontShow === undefined) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: response.result.message,
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          ordenActions.setOrden({
            orden: response.data,
          })
        );
        if (dontShow === undefined) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la orden",
        })
      );
    }
  };
};
export const SendCalendar = (email,name, dontShow) => {
  return async (dispatch) => {
    if (dontShow === undefined) {
      dispatch(
        uiActions.showNotification({
          status: "pending",
          title: "Solicitando envio del calendario",
          message: "Solicitando envío del calendario al servidor.",
        })
      );
    }
    const getUsuarioInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/sendCalendar`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Email: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo enviar el calendario");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getUsuarioInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          ordenActions.setOrden({
            orden: response.data,
          })
        );

        if (dontShow === undefined) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: "calendario enviado correctamente",
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          ordenActions.setOrden({
            orden: response.data,
          })
        );
        if (dontShow === undefined) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo enviar el calendario",
        })
      );
    }
  };
};
